import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, remove } from 'kapix-components-vue3'
import blocPreviewRessourceHubRessourcesComponentStoreCustom from './store.custom'

const storeName = 'blocPreviewRessourceHubRessourcesComponent'
const customImplement: CustomStoreImplementationOptions = blocPreviewRessourceHubRessourcesComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function blocPreviewRessourceHubRessourcesComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          creerMonAutoEntreprise: undefined as Nullable<string>,
          loremIpsumDolorSit: undefined as Nullable<string>,
          indication: undefined as Nullable<string>,
          picture: undefined as Nullable<string | File>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $creerMonAutoEntreprise (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.creerMonAutoEntreprise,
          set: (value) => {
            this.$data.creerMonAutoEntreprise = value
            this.$emit('update:creerMonAutoEntreprise', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $loremIpsumDolorSit (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.loremIpsumDolorSit,
          set: (value) => {
            this.$data.loremIpsumDolorSit = value
            this.$emit('update:loremIpsumDolorSit', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $indication (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.indication,
          set: (value) => {
            this.$data.indication = value
            this.$emit('update:indication', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $picture (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.picture,
          set: (value) => {
            this.$data.picture = value
            this.$emit('update:picture', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return blocPreviewRessourceHubRessourcesComponentFactory(storeId)()
}

export const blocPreviewRessourceHubRessourcesComponentRaw = blocPreviewRessourceHubRessourcesComponentFactory()
export const blocPreviewRessourceHubRessourcesComponent = () => blocPreviewRessourceHubRessourcesComponentRaw() as MergeCustomStore<typeof blocPreviewRessourceHubRessourcesComponentStoreCustom.instance>
